// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type SlackListsItemsListResponse = SlackAPIResponse & {
  error?: string;
  items?: Item[];
  needed?: string;
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
  warning?: string;
};

export interface Item {
  created_by?: string;
  date_created?: number;
  fields?: Field[];
  id?: string;
  list_id?: string;
  updated_by?: string;
  updated_timestamp?: string;
}

export interface Field {
  checkbox?: boolean;
  column_id?: string;
  key?: string;
  rich_text?: RichText[];
  text?: string;
  value?: boolean | string;
}

export interface RichText {
  block_id?: string;
  elements?: RichTextElement[];
  type?: string;
}

export interface RichTextElement {
  elements?: ElementElementClass[];
  type?: string;
}

export interface ElementElementClass {
  text?: string;
  type?: string;
}

export interface ResponseMetadata {
  messages?: string[];
  next_cursor?: string;
}
